import { useAtomValue } from 'jotai';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';

import { CompanyProfileDrawer } from '../../job-company-profile';
import { jobPositionApiDataAtom } from '../job-position.atoms';

import { cn } from '@restworld/utils-common';
export const CompanyProfileButton = () => {
  const jobPositionApiData = useAtomValue(jobPositionApiDataAtom);

  return jobPositionApiData?.show_restaurant_details ? (
    <Wrapper>
      <CompanyProfileDrawer buttonIcon={BuildingOfficeIcon} />
    </Wrapper>
  ) : null;
};

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('block lg:hidden', className)} {...props} />
);
